import { useQuery } from '@tanstack/react-query'

import { useGlobalState } from '@/hooks/useGlobalState'

/**
 * Read-only access to the channel's `is_media_mode` flag.
 *
 * Media mode changes how channels are handled across the app — currently:
 * - Adds a "Media Access" column to the CM table (subscriber vs. free)
 *
 * The flag is set by the backend per sponsor and not editable from the portal.
 * Wraps the same `['sponsor', 'info']` query other code uses, so the data is
 * shared/cached and a single network request feeds every consumer.
 */
export function useIsMediaMode() {
  const { api } = useGlobalState()

  const sponsorInfoQuery = useQuery({
    queryKey: ['sponsor', 'info'],
    queryFn: () => api.getSponsorInfo(),
    staleTime: 5 * 60 * 1000,
  })

  return {
    isMediaMode: sponsorInfoQuery.data?.isMediaMode ?? false,
    isLoading: sponsorInfoQuery.isLoading,
    isReady: sponsorInfoQuery.isSuccess,
  }
}
